/*eslint-disable*/
import { useState, useEffect } from "react";
import client from "../../common/api";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import CreateModal from "./CreateModal";
import { useTranslation } from "react-i18next";
import './roadmap.public.scss';

const FeatureRequestCreate = ({
    getRoadmapDetails,
    companyID,
    authModalToggle,
    tokenExists,
    getUserToken,
    filterRoadmaps,
}) => {
    const activeSpace = window.location.host.split('.')[0];
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [allCategories, setAllCategories] = useState([]);
    const [roadmapPayload, setRoadmapPayload] = useState({
        title: '',
        description: '',
        createdBy: '',
    });
    const [payloadValid, setPayloadValid] = useState({
        status: true,
        error: ''
    });
    const [featureSubmit, setfeatureSubmit] = useState({
        show: false,
        text: '',
        type: ''
    });
    const [featureSubmitLoader, setfeatureSubmitLoader] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('all');

    const { t } = useTranslation();

    const hostUrl = window.location.host;

    const featurePayloadValid = () => {
        if (roadmapPayload.title === '' || roadmapPayload.description === '') {
            return false;
        } else {
            return true;
        }
    };

    const toggleCreateModal = () => {
        setShowCreateModal(!showCreateModal);
    };

    const fetchCategories = () => {
        const _hostUrl = hostUrl.replace("www.", "");
        const payLoad = {
            activeSpaceName: activeSpace,
            url: _hostUrl
        };
        client.get('/feedback/get/categories', { params: payLoad }).then(response => {
            const codeResp = response.data;
            if (codeResp.success) {
                const sortedCategories = codeResp.data.sort((a, b) => new Date(b.created_at['$date']) - new Date(a.created_at['$date']));
                setAllCategories(sortedCategories);
            }
        })
    };

    const submitFeatureReq = () => {
        const userDetails = getUserToken();
        const _hostUrl = hostUrl.replace("www.", "");   // for custom url.

        if (!userDetails) {
            authModalToggle('signup');
            return;
        }

        const isValid = featurePayloadValid();
        if (!isValid) {
            setPayloadValid({
                status: false,
                error: 'Please fill all the fields'
            });

            setTimeout(() => {
                setPayloadValid({
                    status: true,
                    error: 'Please fill all the fields'
                });
            }, 3000);
            return;
        }
        else {
            const payload = {
                ...roadmapPayload,
                email: userDetails?.email,
                is_guest_user: userDetails?.is_guest_user,
                url: _hostUrl
            };
            payload.activeSpaceName = activeSpace;
            setfeatureSubmitLoader(true);
            client.post(`/feedback/public/create/${companyID}`, payload).then(response => {
                if (response.data.success) {
                    setfeatureSubmit({
                        show: true,
                        text: response.data.msg,
                        type: 'primary'
                    });

                    // reset form & fetch roadmaps
                    setTimeout(() => {
                        setfeatureSubmit({
                            show: false,
                        });
                        getRoadmapDetails(companyID);
                        setRoadmapPayload({
                            title: '',
                            description: '',
                            createdBy: '',
                        });
                    }, 3000);
                } else {
                    setfeatureSubmit({
                        show: true,
                        text: response.data.msg,
                        type: 'danger'
                    });
                }
            }).finally(() => {
                setfeatureSubmitLoader(false);
            });
        }
    };

    const filterOnCategory = (category) => {
        if (category === 'all') {
            return allCategories;
        } else {
            return allCategories.filter(category => category.name === category);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    return (
        <div className="feature-create">
            <CreateModal
                featureSubmitLoader={featureSubmitLoader}
                toggleCreateModal={toggleCreateModal}
                type="feature"
                submitFeatureReq={submitFeatureReq}
                roadmapPayload={roadmapPayload}
                setRoadmapPayload={setRoadmapPayload}
                featureSubmit={featureSubmit}
                payloadValid={payloadValid}
                showCreateModal={showCreateModal}
            />
            <div className="feature-create-header">
                <p className="feature-heading">{t('submit_feature_req')}</p>
                <p className="feature-sub-heading">
                    {t('got_idea_submit_feature_req')}
                </p>
            </div>
            <div className="feature-create-btn-wrapper">
                <button className="btn pl-btn feature-create-btn" onClick={toggleCreateModal}>
                    <FontAwesomeIcon icon={faPlus} style={{ marginRight: '5px' }} />
                    {t('submit_post')}
                </button>
            </div>

            <div className="public-category-wrapper d-none d-lg-block">
                <div
                    className={`category-item ${selectedCategory === 'all' ? 'active' : ''}`}
                    onClick={() => {
                        setSelectedCategory('all');
                        filterRoadmaps('all');
                    }}>
                    {t('all')}
                </div>
                {
                    allCategories.map((category) => {
                        // return if category.total_roadmaps > 0 
                        if (category.total_roadmaps > 0) {
                            return (
                                <div key={category.name}
                                    className={`category-item ${selectedCategory === category.name ? 'active' : ''}`}
                                    onClick={() => {
                                        setSelectedCategory(category.name);
                                        filterRoadmaps(category);
                                    }}>
                                    <div className="emoji-wrapper">
                                        {category.emoji}
                                    </div>
                                    <div className="category-name-wrapper">
                                        {category.name}
                                    </div>

                                    <div className="total-roadmaps-wrapper">
                                        {category.total_roadmaps}
                                    </div>
                                </div>
                            )
                        }
                    })
                }
            </div>

            {
                !tokenExists && (
                    <div className="login-info">
                        {/* <p className="not_login">Not Loggedin. Already ProductLogz user? <a target="_blank" href="https://app.productlogz.com/login"><span>Login here</span> </a> </p> */}
                        <p className="existing-user" onClick={() => authModalToggle('signup')}>{t("not_logged_in")}</p>
                    </div>
                )
            }
        </div>
    );
};

export default FeatureRequestCreate;
